export const getters = Object.assign({})
